
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from './components/theme-provider'
import App from './App.tsx'
import './index.css'
import { logger } from './lib/logger'

// Initialize logger to capture console logs
logger.init();

// QueryClient configuration - must be ABOVE ThemeProvider
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,        // 5 minutes - data stays fresh
      gcTime: 10 * 60 * 1000,          // 10 minutes - cache retention
      refetchOnWindowFocus: false,     // Don't refetch on window focus
      refetchOnMount: false,           // Don't refetch on mount
      refetchOnReconnect: true,        // Refetch on reconnect
      retry: 1,                        // Single retry
    },
    mutations: {
      retry: 0,                        // No retry for mutations
    },
  },
});

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <ThemeProvider defaultTheme="light" storageKey="meu-controle-financeiro-tema">
          <App />
        </ThemeProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
} else {
  console.error("Root element not found");
}
